import StoreClient from "../Client";

export const FETCH_ACTION = "identity.FETCH";
export const RECEIVE_ACTION = "identity.RECEIVE";
export const ERROR_ACTION = "identity.ERROR";
export const AUTH_ERROR_ACTION = "identity.AUTH_ERROR";

const checkRoleInclude = role =>
  role.includes("ADMIN") ||
  role.includes("OFFICE") ||
  role.includes("EDITOR") ||
  role.includes("VIEWER") ||
  role.includes("MOBILE");

export const fetchAction = () => dispatch =>
  dispatch({
    type: FETCH_ACTION
  });

export const receive = data => dispatch =>
  dispatch({
    type: RECEIVE_ACTION,
    ...data
  });

export const error = message => dispatch =>
  dispatch({
    type: ERROR_ACTION,
    message
  });

export const authError = message => dispatch =>
  dispatch({
    type: AUTH_ERROR_ACTION,
    message
  });

const GET_IDENTITY = /* GraphQL */ `
  {
    identity: me {
      id
      username
      email
      status
      role
      profile {
        id
        name
        image
        city {
          id
          name
        }
      }
      employeeInfo {
        id
        phones
        theatre {
          id
          originalId
          city {
            id
          }
        }
      }
    }
  }
`;

export const fetchData = authKey => dispatch => {
  dispatch(fetchAction());
  return StoreClient.setHeader("authKey", authKey)
    .request(GET_IDENTITY)
    .then(res => {
      const { identity } = res;
      if (!identity) {
        return authError("Unauthorized");
      }
      if (!(identity.role && checkRoleInclude(identity.role))) {
        return authError("Forbitten");
      }
      return receive(identity);
    })
    .catch(e => authError(e.message))
    .then(dispatch);
};



// WEBPACK FOOTER //
// ./src/action/identity.js